/*
Monotype Foundry Platform API
Version 1.0.0
*/
'use strict'

var Api = require('./config')
var controllers = require('./controllers')

for (var controller in controllers) {
  Api[controller] = controllers[controller]
}

module.exports = Api
